module.exports = __webpack_public_path__ + "static/ornament-02-1771637efdaf5f402553315288a60eb5.png";